import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeSlug from 'rehype-slug';

interface MarkdownProperties {
  markdown: string;
}

const Markdown = ({ markdown }: MarkdownProperties) => (
  <ReactMarkdown
    rehypePlugins={[rehypeSlug] as ReactMarkdown.PluggableList}
  >
    {markdown}
  </ReactMarkdown>
);

export default Markdown;
